// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/bundle." + {"321":"3ec1a7ee5524f32ab8c6","476":"d7dead81a561d62db493"}[chunkId] + ".min.js";
};